import { createContext, useContext, useMemo, type ReactNode } from 'react';

type ChatEmbedContextValue = {
  openEmbeddedUrl: (url: string) => void;
};

const ChatEmbedContext = createContext<ChatEmbedContextValue | null>(null);

export function ChatEmbedProvider({
  children,
  openEmbeddedUrl,
}: {
  children: ReactNode;
  openEmbeddedUrl: (url: string) => void;
}) {
  const value = useMemo(() => ({ openEmbeddedUrl }), [openEmbeddedUrl]);
  return <ChatEmbedContext.Provider value={value}>{children}</ChatEmbedContext.Provider>;
}

// eslint-disable-next-line react-refresh/only-export-components -- paired hook for CTAButton inside GeofleetPublicChatWidget
export function useChatEmbed(): ChatEmbedContextValue | null {
  return useContext(ChatEmbedContext);
}
